import {Component, HostBinding, Input} from '@angular/core';
import {BillingVer202212StatusForLayout} from '../../layout/billing-ver202212-status-for-layout';

@Component({
  selector: 'app-warning-error-menu',
  templateUrl: './warning-error-menu.component.html',
})
export class WarningErrorMenuComponent {
  @HostBinding('class.header-menu-item') warningError = true;
  @Input() balanceStatus: BillingVer202212StatusForLayout;

  constructor() {
  }
}
